import styled from 'styled-components';
import { Radio } from 'antd';

export const StyledRadio = styled(Radio)<{
  borderColor?: string;
}>`
  .ant-radio {
    border-color: ${({ borderColor, theme }) =>
      borderColor || theme.palette.secondary.main} !important;
  }

  .ant-radio-inner {
    border-color: ${({ borderColor, theme }) =>
      borderColor || theme.palette.secondary.main} !important;
  }

  &:hover .ant-radio-inner {
    border-color: ${({ borderColor, theme }) =>
      borderColor || theme.palette.secondary.main} !important;
  }

  &.ant-radio-wrapper-checked .ant-radio-inner {
    border-color: ${({ borderColor, theme }) =>
      borderColor || theme.palette.secondary.main} !important;
  }
`;

export const StyledRadioGroup = styled(Radio.Group)<{
  borderColor?: string;
}>`
  .ant-radio-wrapper {
    .ant-radio {
      border-color: ${({ borderColor, theme }) =>
        borderColor || theme.palette.secondary.main} !important;
    }

    .ant-radio-inner {
      border-color: ${({ borderColor, theme }) =>
        borderColor || theme.palette.secondary.main} !important;
    }

    &:hover .ant-radio-inner {
      border-color: ${({ borderColor, theme }) =>
        borderColor || theme.palette.secondary.main} !important;
    }

    &.ant-radio-wrapper-checked .ant-radio-inner {
      border-color: ${({ borderColor, theme }) =>
        borderColor || theme.palette.secondary.main} !important;
    }
  }
`;
